import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import InvoiceExportRequest from './InvoiceExportRequest';

export interface Props extends BaseModalProps {
	isSuperAdmin?: boolean;
}

const InvoiceExportRequestModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.invoiceExportRequest.modalTitle'>
			<InvoiceExportRequest
				onSuccess={props.onClose}
				isSuperAdmin={props.isSuperAdmin}
			/>
		</BaseModal>
	);
};

export default InvoiceExportRequestModal;
